var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRefreshDisableIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.578 7.367c1.39-2.54 3.988-4.25 6.963-4.25 3.374 0 6.262 2.198 7.455 5.313m-11.977 0H4V4.18m15.422 11.687c-1.39 2.54-3.988 4.25-6.963 4.25-3.374 0-6.262-2.197-7.455-5.312m11.977 0H21v4.25",
    stroke: "#10121C",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefreshDisableIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RefreshDisableIcon.ce077775.svg";
export { ForwardRef as ReactComponent };